import React from "react"
import PropTypes from "prop-types"
import { lexMoment } from '../utils/lexTime'


class MeetingSchedule extends React.Component {
  constructor(props) {
    super(props)

    const {meeting_time, lang_one, lang_two} = this.props

    this.state = {
      meeting_time: meeting_time,
      lang_one: lang_one,
      lang_two: lang_two
    }
  }

  render() {
    if(this.state.lang_one !== null && this.state.lang_two !== null) {
      const meetingTime = lexMoment(this.state.meeting_time)
      const langOneEnd = meetingTime.clone().add(30, 'minutes')
      const langTwoEnd = meetingTime.clone().add(60, 'minutes')

      return(
        <div className="upcomingLexSchedule">
          <div className="upcomingLexSchedule__row">
            <div className="upcomingLexSchedule__tag upcomingLexSchedule__tag--langOne">
              <span>{this.state.lang_one.locale}</span>
            </div>
            <div className="upcomingLexSchedule__copy upcomingLexSchedule__copy--langOne">
              <p className="upcomingLexSchedule__time">
                {meetingTime.format("h:mm A")} – {langOneEnd.format("h:mm A")}
              </p>
              <p className="upcomingLexSchedule__language">{this.state.lang_one.native} Only</p>
            </div>
          </div>
          <div className="upcomingLexSchedule__row">
            <div className="upcomingLexSchedule__tag upcomingLexSchedule__tag--langTwo">
              <span>{this.state.lang_two.locale}</span>
            </div>
            <div className="upcomingLexSchedule__copy upcomingLexSchedule__copy--langTwo">
              <p className="upcomingLexSchedule__time">
                {langOneEnd.format("h:mm A")} – {langTwoEnd.format("h:mm A")}
              </p>
              <p className="upcomingLexSchedule__language">{this.state.lang_two.native} Only</p>
            </div>
          </div>
        </div>
      )
    }
    return <h3>Invalid Times</h3>;
  }
}

export default MeetingSchedule;
